import React from 'react'
import * as bs4 from 'reactstrap'
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../../Navbar'
import { ScaleLoader } from 'react-spinners';
import ReactGA from 'react-ga';
const { proxy } = require('../../../ip_api.config')

class Acc_MasterOption extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            previewItem: '',
            onPage: 'Preview',
            arr_temp_edit: [],
            arr_save: [],
            status: 'ibrand1'
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/Acc/MasterOption');

        if (localStorage.getItem("ID_User") !== null) {
            this.preChooseOption()
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    preChooseOption = () => {
        let status
        let type = localStorage.getItem("type")

        if (type === null || type === '') {
            status = 'ibrand1'
        } else {
            console.log('type', type)
            status = type
        }

        this.setState({ isLoading: false, status: status }, () => {
            this.chooseOption(status)
        })
    }

    chooseOption = (value) => {
        console.log('value', value)
        this.setState({ status: value, show_item: '', arr_save: [] }, () => {
            localStorage.setItem("type", this.state.status)
            this.getMaster_Option(value);
        })
    }

    getMaster_Option = (type) => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arr = []
        let url = proxy.server + '/acc/getMaster_Option'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: '',
                type: type
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td><bs4.Button color='danger' size='sm' onClick={() => this.Delete_item(val.id)}>DEL</bs4.Button></td>
                            <td>{val.code}</td>
                            <td>{val.description}</td>
                        </tr>
                    )
                }, this)
                this.setState({ previewItem: arr, isLoading: false, result: responseJson.result })
            })
    }

    getItem_Edit = () => {
        const { status, result } = this.state
        this.setState({ isLoading: true, onPage: 'Edit' })
        let arr = []
        result.map(function (val, i) {
            arr.push(
                <tr>
                    <td style={{ justifyContent: 'center' }}>
                        <bs4.Col>
                            <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                onChange={(e) => this.checkItem(e.target.checked, val.id)} />
                        </bs4.Col>
                    </td>
                    <td>{val.code}</td>
                    <td>{val.description}</td>
                </tr>
            )
        }, this)
        this.setState({ previewItem: arr, isLoading: false })
    }

    checkItem = (check, id) => {
        let data = {}
        if (check === true) {
            data = {
                id: id,
            }
            let arr = this.state.arr_temp_edit.concat(data)
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        } else {
            let arr = this.state.arr_temp_edit

            for (var i = arr.length; i--;) {
                if (arr[i].id === id) arr.splice(i, 1);
            }
            this.setState({
                arr_temp_edit: arr
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        }
    }

    goto_edit = () => {
        this.props.history.push({
            pathname: '/acc/editMasterOption',
            state: { id_edit: this.state.arr_temp_edit, type: this.state.status }
        })
    }

    Delete_item = (id) => {
        const { status } = this.state
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/acc/delete_Option'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                    type: status
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.setState({ arr_save: [], show_item: '' }, () => this.chooseOption(this.state.status))
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถลบข้อมูลได้ กรุณาตรวจสอบอีกครั้ง')
                        })
                    }
                })
        }
    }

    addData = () => {
        const { arr_save, status } = this.state
        let arr = []
        let temp
        let data
        // arr_check.map(function (val, i) {
        data = {
            type: status,
            code: '',
            description: '',
        }

        arr.push(data)

        temp = arr_save.concat(arr)

        this.setState({
            arr_save: temp
        }, () => {
            console.log('arr_save', this.state.arr_save)
            this.showItem()
        })
    }

    showItem = () => {
        const { arr_save, status } = this.state
        let arr = []
        arr_save.map(function (val, i) {
            arr.push(
                <tr>
                    <td><bs4.Button color='danger' size='sm' onClick={() => this.onDelete(i)}>X</bs4.Button></td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="code" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12'>
                            <bs4.Input type="text" name="description" onBlur={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} />
                        </bs4.Col>
                    </td>
                </tr>
            )
        }, this)

        this.setState({ show_item: arr }, () => {
            console.log('arr_save', this.state.arr_save)
        })
    }

    onDelete = (index) => {
        this.state.arr_save.splice(index, 1)
        this.setState({
            arr_save: this.state.arr_save,
        }, () => {
            this.showItem()
        })
    }

    handleChangeItem = (index, name, value) => {
        if (name === 'code') {
            this.state.arr_save[index].code = value
        } else if (name === 'description') {
            this.state.arr_save[index].description = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            this.showItem()
        })
    }

    saveItem = () => {
        const { status, arr_save } = this.state
        // console.log('arr_save',arr_save)
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            let url = proxy.server + '/acc/insert_Option'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    arr: arr_save,
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        alert('บันทึกสำเร็จ')
                        this.setState({ arr_save: [], show_item: '' }, () => this.chooseOption(this.state.status))
                    } else {
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Acc'} menu={'Acc_MasterBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 10 }}>
                    <bs4.Label style={{ fontSize: 23, fontWeight: 500, marginRight: 10 }}>ข้อมูล Option ต่างๆ</bs4.Label>
                    <bs4.Col sm='4'>
                        <bs4.Input type='select' onChange={(e) => this.chooseOption(e.target.value)}>
                            <option value=''>------</option>
                            <option value='Ibrand1'>Ibrand1</option>
                            <option value='Ibrand3'>Ibrand3</option>
                            <option value='Ibrand4'>Ibrand4</option>
                            <option value='Unit'>Unit</option>
                            <option value='LocationProduction'>สถานที่ผลิต</option>
                            <option value='LocationPack'>สถานที่แพ็ค</option>
                        </bs4.Input>
                    </bs4.Col>
                    {
                        this.state.onPage === 'Preview'
                            ? <div>
                                <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.addData()}>ADD DATA</bs4.Button>
                                <bs4.Button color="secondary" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getItem_Edit()}>EDIT</bs4.Button>
                            </div>
                            : <div>
                                <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.goto_edit()}>GO TO EDIT</bs4.Button>
                                <bs4.Button outline color="secondary" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.chooseOption(this.state.status)}>CANCEL</bs4.Button>
                            </div>

                    }
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>

                <bs4.FormGroup row style={{ marginLeft: 10, marginTop: 30 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 10 }}>{this.state.status}</bs4.Label>
                    {
                        this.state.arr_save.length > 0
                            ? <div>
                                <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.saveItem()}>SAVE</bs4.Button>
                                <bs4.Button outline color="secondary" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.setState({ show_item: '', arr_save: [] }, () => this.chooseOption(this.state.status))}>CANCEL</bs4.Button>
                            </div>
                            : ''
                    }
                </bs4.FormGroup>

                <bs4.Table bordered hover>
                    <thead style={{ backgroundColor: '#8f8f8f', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th style={{ backgroundColor: '#fff' }} width='2%'></th>
                            {/* <th>type</th> */}
                            <th>code</th>
                            <th>description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.show_item}
                        {this.state.previewItem}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Acc_MasterOption